import { QueryKeys } from "@/constants/Query";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import type * as fhirTypes from "fhir/r4";

interface FileResponse {
  documentReference: fhirTypes.DocumentReference;
}

interface UseFileParams {
  patientId?: string;
  documentReferenceId?: string;
  enabled?: boolean;
}

export const useFile = ({
  patientId,
  documentReferenceId,
  enabled = true,
}: UseFileParams) => {
  return useQuery<fhirTypes.DocumentReference>({
    queryFn: async () => {
      const response = await axiosInstance.get<FileResponse>(
        `/charting/files/document-reference/${documentReferenceId}`,
      );
      return response.data.documentReference;
    },
    queryKey: QueryKeys.Patient.MedicalRecords.Files.BY_ID(
      patientId,
      documentReferenceId,
    ),
    enabled: enabled && !!documentReferenceId,
  });
};
